<app-template-text [counter]="counter" [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [label]="label" />
